<template>
  <div
    class="fshr-cardBadgeVue"
    :class="[
      color && `fshr-cardBadgeVue--color-${color}`,
      size && `fshr-cardBadgeVue--size-${size}`,
      isAbsolute && `fshr-cardBadgeVue--isAbsolute`,
      isBottom && `fshr-cardBadgeVue--isBottom`,
    ]"
  >
    <span class="fshr-cardBadgeVue__label">{{ label }}</span>
    <span v-if="caption" class="fshr-cardBadgeVue__caption">
      {{ caption }}
    </span>
  </div>
</template>

<script>
const BADGE_STYLES = ["white"];
const BADGE_SIZES = ["md", "lg"];

export default {
  name: "card-badge",
  props: {
    /**
     * Text label of CardBadge
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * Text caption of CardBadge
     */
    caption: {
      type: String,
      required: false,
    },
    /**
     * Define color of CardBadge
     */
    color: {
      type: String,
      required: false,
      validator: (value) => value && BADGE_STYLES.includes(value),
    },
    /**
     * Define size of CardBadge
     */
    size: {
      type: String,
      required: false,
      default: null,
      validator: (value) => value && BADGE_SIZES.includes(value),
    },
    /**
     * Define if CardBadge is absolutely positioned within card
     */
    isAbsolute: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Define if CardBadge is absolutely positioned to bottom left within card
     */
    isBottom: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
